import { getCaptainWorkflow } from './captainWorkflow';

// 客队队长确认选队前，分队名单始终使用中性的 A/B 代号。
export const isAwaitingRedTeamChoice = (gameDetail = {}) => {
    const { redConfirm } = getCaptainWorkflow(gameDetail);
    return redConfirm === null || redConfirm === 0;
};

export const getReadyTeamName = (gameDetail = {}, teamIndex) => {
    if (isAwaitingRedTeamChoice(gameDetail)) {
        return teamIndex === 1 ? 'A队' : 'B队';
    }

    if (teamIndex === 1) {
        if (gameDetail?.greenName) return gameDetail.greenName;
        if (gameDetail?.gameType === 2) return '华西科朋足球队';
        if (gameDetail?.greenCaptain?.name) return `${gameDetail.greenCaptain.name.charAt(0)}队`;
        return 'A队';
    }

    if (teamIndex === 2) {
        if (gameDetail?.redName) return gameDetail.redName;
        if (gameDetail?.redCaptain?.name) return `${gameDetail.redCaptain.name.charAt(0)}队`;
        return 'B队';
    }

    return 'Team';
};

// 待选队员弹窗在客队队长选队前保留 A/B 代号，选队后再展示队伍实际名称。
export const getPendingMemberTeamName = (gameDetail = {}, teamIndex) => {
    if (gameDetail?.redCaptainConfirm == null || Number(gameDetail.redCaptainConfirm) < 1) {
        return teamIndex === 1 ? 'A队' : 'B队';
    }
    return getReadyTeamName(gameDetail, teamIndex);
};
